<script>
import NodeBaseMixin from '@/mixins/node-base.mixin'
import { sync } from 'vuex-pathify'

export default {
    name: 'NodeCard',
    mixins: [
        NodeBaseMixin
    ],
    props: {
        node: null
    },
    computed: {
        variableList: sync('scenario/variableList'),
        cardTitle () {
            return this.node.config.card_type_id ? this.node.config.card_type_id.replaceAll('_', ' ') : ''
        },
        cardActive: sync('debug/cardActive'),
        isCardActive () {
            return this.cardActive && this.node.id === this.cardActive.id
        }
    },
    methods: {
        onSelectCard () {
            this.node.metadata.forEach((meta) => {
                this.variableList.push({
                    name: meta.key,
                    builtin: 0
                })
            })
            this.cardActive = this.node
        }
    }
}
</script>

<template>
    <div class="card-wrapper" ref="nodeRef" @click="onSelectCard()"
         :class="{active: isCardActive, 'card-error': node.error}">
        <div class="card-header" :class="{pass: node.condition_status, error: node.error}">
            <img :src="'/img/scenario/card/normal/' + node.config.card_type_id + '.svg'" alt=""
                 style="width: 20px; height: 20px">
            {{ cardTitle | capitalize }}
        </div>
        <div class="card-content">
            {{ node.config.name.split('-')[0].trim() }}
        </div>
        <div class="status-icon" v-if="node.error">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path
                    d="M10.5 20C4.97715 20 0.5 15.5228 0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10C20.5 15.5228 16.0228 20 10.5 20ZM10.5 8.5858L7.67157 5.75736L6.25736 7.17157L9.0858 10L6.25736 12.8284L7.67157 14.2426L10.5 11.4142L13.3284 14.2426L14.7426 12.8284L11.9142 10L14.7426 7.17157L13.3284 5.75736L10.5 8.5858Z"
                    fill="#DC3632"/>
            </svg>
        </div>
        <div class="status-icon" v-else-if="node.condition_status">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z" fill="#70C154"/>
            </svg>
        </div>
        <div class="status-icon" v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path d="M10.5 20C4.97715 20 0.5 15.5228 0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10C20.5 15.5228 16.0228 20 10.5 20ZM9.5 13V15H11.5V13H9.5ZM9.5 5V11H11.5V5H9.5Z" fill="#868686"/>
            </svg>
        </div>
    </div>
</template>

<style scoped lang="scss">
.card-wrapper {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #D2D2D2;
    background: #D2D2D2;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    gap: 1px;

    &.card-error {
        border: 1px solid #DC3632;
    }

    .status-icon {
        position: absolute;
        top: -10px;
        right: -10px;
        border-radius: 100px;
        background-color: white;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.active {
        border-radius: 4px;
        border-color: #0052CC;
    }

    .card-header {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #DFDFDF;
        padding: 12px;
        border-radius: 4px 4px 0 0;
        font-weight: bold;
        border: none;
        &.error {
            background-color: #FCEFEF !important;
        }
        &.pass {
            background: #E7F8E2;
        }
    }

    .card-content {
        padding: 4px 12px;
        background-color: #FFF;
        border-radius: 0 0 4px 4px;
    }
}
</style>
